import { createAuthClient } from 'better-auth/react';

/** Same-origin Better Auth client. The web Worker forwards `/api/auth/*` to the API. */
export const authClient = createAuthClient({
    basePath: '/api/auth',
    fetchOptions: {
        // Resolve fetch at call time so tests can stub `globalThis.fetch` after import.
        customFetchImpl: (input, init) => globalThis.fetch(input, init),
    },
});
